import React from "react";
import Hero from "../../components/medical/Hero";
import HighlightedContactSection from "../../components/HighlightedContactSection";

const PARAGRAPH_CLASS =
  "mt-3 text-sm leading-relaxed text-gray-700 md:text-base";

const TESTIMONIALS = [
  { name: "Rudolf G. aus Kaufbeuren", text: "Effizient und wirklich auf den Punkt gebracht." },
  { name: "Margit K. aus Lüneburg", text: "Am Anfang hart zu hören, aber herzlich und dabei offen und direkt." },
  { name: "Gitte H. aus Kulmbach", text: "Eine Frau, die sofort erkennt was nötig ist. Man muss es nur umsetzen. Den Willen von mir, einen Input von einem Profi zu holen, habe ich nie bereut. Wichtig ist, die guten Tipps danach dann auch umzusetzen!" },
  { name: "Jürgen R. aus Düsseldorf", text: 'Ich war überrascht über die schnelle „Diagnose".' },
  { name: "Ludmila O. aus Gera", text: "Man darf keine Vorbehalte haben und muss sich drauf einlassen. Wunderbar." },
  { name: "Denis S. aus Fulda", text: "Ist wie bei Zahnarzt, erst tut es weh. Aber dann wird es gut." },
  { name: "Jörg W. aus Würzburg", text: "Schon knackig, wer empfindlich ist, sollte lieber Zuhause bleiben." },
];

export default function KarrierePage() {
  return (
    <>
      <Hero
        title="Karriere"
        subheading="Ihre nächsten Schritte mit unserer Karriereberatung."
      />
      <section className="bg-white pt-0 pb-16 md:pb-24">
        {/* 1. Karriereberatung */}
        <div id="section-karriere-beratung" className="border-b border-gray-100 py-12 md:py-16 first:pt-8">
          <div className="container-app mx-auto flex flex-col gap-8 px-4 md:flex-row md:gap-12 lg:gap-16">
            <div className="flex-shrink-0 md:w-36 lg:w-40">
              <span className="detail-side-label text-xs font-semibold uppercase tracking-[0.2em] text-gray-700">
                KARRIEREBERATUNG
              </span>
            </div>
            <div className="min-w-0 flex-1 max-w-4xl">
              <h2 className="text-2xl font-semibold leading-snug text-gray-900 md:text-3xl">
                Fachwissen, das Ihnen als Kandidat nutzt
              </h2>
              <p className={PARAGRAPH_CLASS}>
                Personalberatung, Personalvermittlung, all die Themen sind die Kernpunkte unserer Beratung. Wir beraten seit Jahrzehnten Kunden und Kandidaten, da ist auch für Sie als Bewerber ein geballtes Fachwissen dahinter, welches Ihnen viel nutzen wird. Wir wissen haargenau wie Sie als Kandidat Ihre wertvollen beruflichen Kenntnisse und Erfahrungen richtig in Szene setzen.
              </p>
            </div>
          </div>
        </div>

        {/* 2. Stimmen von Kandidaten */}
        <div id="section-karriere-stimmen" className="border-b border-gray-100 py-12 md:py-16">
          <div className="container-app mx-auto flex flex-col gap-8 px-4 md:flex-row md:gap-12 lg:gap-16">
            <div className="flex-shrink-0 md:w-36 lg:w-40">
              <span className="detail-side-label text-xs font-semibold uppercase tracking-[0.2em] text-gray-700">
                KANDIDATENSTIMMEN
              </span>
            </div>
            <div className="min-w-0 flex-1 max-w-4xl">
              <h2 className="text-2xl font-semibold leading-snug text-gray-900 md:text-3xl">
                Stimmen von Kandidaten
              </h2>
              <div className="mt-6 grid gap-4 sm:grid-cols-2">
                {TESTIMONIALS.map((t, i) => (
                  <div key={i} className="rounded-xl border border-gray-200 bg-white p-5 shadow-sm">
                    <p className="text-sm leading-relaxed text-gray-700 md:text-base">„{t.text}"</p>
                    <p className="mt-3 text-sm font-medium text-gray-900">{t.name}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* 3. Eine Stunde reicht */}
        <div id="section-karriere-click" className="border-b border-gray-100 py-12 md:py-16">
          <div className="container-app mx-auto flex flex-col gap-8 px-4 md:flex-row md:gap-12 lg:gap-16">
            <div className="flex-shrink-0 md:w-36 lg:w-40">
              <span className="detail-side-label text-xs font-semibold uppercase tracking-[0.2em] text-gray-700">
                KARRIERECLICK
              </span>
            </div>
            <div className="min-w-0 flex-1 max-w-4xl">
              <h2 className="text-2xl font-semibold leading-snug text-gray-900 md:text-3xl">
                Eine Stunde – genau der richtige Wink
              </h2>
              <p className={PARAGRAPH_CLASS}>
                Wochenlanges Coaching gibt es bei uns nicht im Angebot! Denn SIE als Kandidat und Mensch haben schon so viel Knowhow! Berufliche Erfahrungen haben Sie ohnehin! Immer genügt ein entscheidender Wink mit dem richtigen Blick, von uns. Exakt das bekommen Sie beim Karriereclick von Claudia von Tein, persönlich.
              </p>
              <p className={PARAGRAPH_CLASS}>
                Klar, können Sie danach auch eine Stunde mehr haben, wenn es Ihnen so viel Spaß gemacht hat! Unsere Erfahrungen zeigen jedoch das eine Stunde völlig ausreicht.
              </p>
            </div>
          </div>
        </div>

        {/* 4. Zu guter Letzt – highlighted contact */}
        <HighlightedContactSection
          heading="Zu guter Letzt!"
          description="Wir führen die Karriereberatung gerne via Zoom durch. Bitte buchen Sie Ihre persönliche Stunde (1 Stunde 150.- zzgl. MwSt.) per E-Mail – wir melden uns bei Ihnen."
          buttonText="Jetzt Kontakt aufnehmen"
          sectionId="section-karriere-kontakt"
        />
      </section>
    </>
  );
}
